import { useParams } from 'react-router-dom'

import { PrivateChatScreen } from './private-chat-screen'
import { PrivateMessagesScreen } from './private-messages-screen'

/**
 * `/messages/:id?` route: the legacy private list without an id and the
 * private conversation with one. Both live in the chat feature; the router
 * only needs this single frozen route.
 */
export function MessagesScreen() {
  const { id } = useParams()
  if (id) return <PrivateChatScreen key={id} conversationId={id} />
  return <PrivateMessagesScreen />
}
